module.exports = __webpack_public_path__ + "price-changed.png?923835550c472b9726fe1533d538bae0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price-changed.png
// module id = 992
// module chunks = 2